module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/icon_wavy-line-yellow-438cc2725a4abdfd9f6888a724fdf61f.svg";